import axios from 'axios';

export default {
  getCustomerClasses(){
			return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/customer-classes")
  },
  fetchCountries(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/address/countries")
      .then(response=>{
        return response.data;
      });
  },
  fetchCountriesV2(withResultsIn){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/countries/?withResultsIn="+withResultsIn)
      .then(response=>{
        return response.data;
      });
  },
  getSysProp(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sysProp")
      .then(response=>{
        return response.data;
      });
  },
  getTags(type, active){
    var params={};
    params.type = type;
    params.active = active != null ? active : undefined;
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/tags",{params:params})
      .then(response=>{
        return response.data;
      })
  },
  getOptions(key){
    var params={key};

    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/options",{params})
      .then(response=>{
        return response.data;
      })
  },
  postTag(tag){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/tags",tag)
      .then(response=>{
        return response.data;
      })
  },
  updateTag(tagId, tag){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/tags/"+tagId,tag)
      .then(response=>{
        return response.data;
      })
  },
  deleteTag(tagId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/tags/"+tagId)
      .then(response=>{
        return response.data;
      })
  },
  updateTags(tags){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/tags",tags)
      .then(response=>{
        return response.data;
      })
  },
  getCustomerCustomFieldDefinition(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/custom-fields?type=CUSTOMER")
      .then(response=>{
        return response.data;
      })
  },
  getPOCustomFieldDefinition(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/custom-fields?type=PO")
      .then(response=>{
        return response.data;
      })
  },
  getProductItemsCustomFieldDefinition(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/custom-fields?type=PRODUCT_ITEM")
      .then(response=>{
        return response.data;
      })
  },
  deleteSystemField(id){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/custom-fields/"+id)
  },
  fetchDefaultCustomerSettings(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/customer-settings")
      .then(results=>{
        return results.data;
      })
  }
}
